/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResellerCreateRequest } from '../../models/reseller-create-request';
import { ResellerMasterdata } from '../../models/reseller-masterdata';

export interface PostReseller$Params {
      body: ResellerCreateRequest;
      'Active-Tenant-Identifier': string;
}

export function postReseller(http: HttpClient, rootUrl: string, params: PostReseller$Params, context?: HttpContext): Observable<StrictHttpResponse<ResellerMasterdata>> {
  const rb = new RequestBuilder(rootUrl, postReseller.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResellerMasterdata>;
    })
  );
}

postReseller.PATH = '/resellers';
